import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import { Logo } from '../Logo';
import CustomLink from '../CustomLink';
import { pagePathnames } from '../../pages/page-routes';
import styles from './AppHeader.css';
import { useRouting } from '../../shared/use-routing';
import { useUser } from '../../shared/use-user';
import { logEvent } from '../../../lib/shared/event-logger';
import { EVENT_TYPES } from '../../../lib/shared/event-types';

const cx = classnames.bind(styles);

function AppHeader({ className, isAuthenticated }) {
    const { location, buildPath, stripLangPrefix } = useRouting();
    const { userData } = useUser();
    const { t } = useTranslation();
    const isAccountPage = stripLangPrefix(location.pathname).startsWith(pagePathnames.account);
    const classes = cx({
        root: true,
        [className]: Boolean(className)
    });

    if (isAuthenticated) {
        return (
            <header className={classes}>
                <div className={styles.wrapper}>
                    <Logo url={buildPath(pagePathnames.dashboard)} className={styles.logo} inApp />
                    <nav className={styles.nav} aria-label={t('common.mainNavigation')}>
                        {isAccountPage ? (
                            <span className={cx('link', 'linkDisabled')}>
                                Manage subscription
                            </span>
                        ) : (
                            <CustomLink
                                to={buildPath(pagePathnames.account)}
                                className={styles.link}
                                onClick={() => logEvent(EVENT_TYPES.ACCOUNT_HEADER_LINK_CLICKED, { 'is_active_subscription': userData.isActiveSubscription })}
                            >
                                Manage subscription
                            </CustomLink>
                        )}
                    </nav>
                </div>
            </header>
        );
    }

    return (
        <header className={classes}>
            <div className={styles.secondaryWrapper}>
                <Logo url={buildPath(pagePathnames.dashboard)} inApp />
            </div>
        </header>
    );
}

AppHeader.propTypes = {
    className: PropTypes.string,
    isAuthenticated: PropTypes.bool
};

AppHeader.defaultProps = {
    className: '',
    isAuthenticated: false
};

export {
    AppHeader
};
